import API from '../api';

export const getProductionReadiness = () =>
  API.get('/admin/production-readiness').then((r) => r.data);

export const getLegalCounselAck = () =>
  API.get('/admin/legal/counsel-ack').then((r) => r.data);

export const acknowledgeLegalCounsel = (payload) =>
  API.post('/admin/legal/counsel-ack', payload).then((r) => r.data);

export const legalDocumentUrl = (name) =>
  `/api/admin/legal/documents/${name}`;

export const fetchLegalDocumentText = async (name) => {
  const r = await API.get(`/admin/legal/documents/${name}`, {
    responseType: 'text',
    transformResponse: [(data) => data],
  });
  return typeof r.data === 'string' ? r.data : String(r.data ?? '');
};
